import { OcularMotilityData, Position, PositionWithTimeStamp } from "types/testTypes";
import { SmoothPursuitSnapshot } from "./smoothPursuit";

export function snapshotsToChartData(snapshots: SmoothPursuitSnapshot[]): OcularMotilityData[] {
  return snapshots.map((s) => {
    const targetAngleX =
      s.targetPosition != null
        ? Math.atan2(s.targetPosition.x, s.targetPosition.z) * (180 / Math.PI)
        : null;
    const targetAngleY =
      s.targetPosition != null
        ? Math.atan2(s.targetPosition.y, s.targetPosition.z) * (180 / Math.PI)
        : null;

    const targetPos: Position | null =
      targetAngleX !== null && targetAngleY !== null ? { x: targetAngleX, y: targetAngleY } : null;

    const leftPos: PositionWithTimeStamp | null =
      s.leftGazeAngles && s.leftGazeValid
        ? { x: s.leftGazeAngles.x, y: s.leftGazeAngles.y, timestamp: s.timestamp }
        : null;

    const rightPos: PositionWithTimeStamp | null =
      s.rightGazeAngles && s.rightGazeValid
        ? { x: s.rightGazeAngles.x, y: s.rightGazeAngles.y, timestamp: s.timestamp }
        : null;

    const leftError =
      s.leftEyeError != null
        ? s.leftEyeError
        : leftPos && targetPos
          ? Math.sqrt(Math.pow(leftPos.x - targetPos.x, 2) + Math.pow(leftPos.y - targetPos.y, 2))
          : null;

    const rightError =
      s.rightEyeError != null
        ? s.rightEyeError
        : rightPos && targetPos
          ? Math.sqrt(Math.pow(rightPos.x - targetPos.x, 2) + Math.pow(rightPos.y - targetPos.y, 2))
          : null;

    return {
      leftGazePosition: leftPos,
      rightGazePosition: rightPos,
      targetPosition: targetPos,
      leftEyeError: leftError,
      rightEyeError: rightError,
      leftEyeTangentialVelocity: null,
      rightEyeTangentialVelocity: null,
      timestamp: s.timestamp,
    };
  });
}
